/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptions interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptions(value) {
    if (!('AppId' in value) || value['AppId'] === undefined)
        return false;
    if (!('AuthKey' in value) || value['AuthKey'] === undefined)
        return false;
    if (!('Debug' in value) || value['Debug'] === undefined)
        return false;
    if (!('GameSid' in value) || value['GameSid'] === undefined)
        return false;
    if (!('PlayerId' in value) || value['PlayerId'] === undefined)
        return false;
    if (!('Guest' in value) || value['Guest'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptionsFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AppId': json['AppId'],
        'AuthKey': json['AuthKey'],
        'Debug': json['Debug'],
        'GameSid': json['GameSid'],
        'PlayerId': json['PlayerId'],
        'Guest': json['Guest'],
        'Invite': json['Invite'] == null ? undefined : json['Invite'],
    };
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptionsToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptionsToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AppId': value['AppId'],
        'AuthKey': value['AuthKey'],
        'Debug': value['Debug'],
        'GameSid': value['GameSid'],
        'PlayerId': value['PlayerId'],
        'Guest': value['Guest'],
        'Invite': value['Invite'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptions.js.map